/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeleteManyExternalDealFiltersResponseDTO
 */
export interface DeleteManyExternalDealFiltersResponseDTO {
  /**
   * Number of deleted external deal filters
   * @type {number}
   * @memberof DeleteManyExternalDealFiltersResponseDTO
   */
  deleted: number;
  /**
   * Number of related deals taken offline because no live filter is left
   * @type {number}
   * @memberof DeleteManyExternalDealFiltersResponseDTO
   */
  dealsTakenOffline: number;
}

/**
 * Check if a given object implements the DeleteManyExternalDealFiltersResponseDTO interface.
 */
export function instanceOfDeleteManyExternalDealFiltersResponseDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "deleted" in value;
  isInstance = isInstance && "dealsTakenOffline" in value;

  return isInstance;
}

export function DeleteManyExternalDealFiltersResponseDTOFromJSON(json: any): DeleteManyExternalDealFiltersResponseDTO {
  return DeleteManyExternalDealFiltersResponseDTOFromJSONTyped(json, false);
}

export function DeleteManyExternalDealFiltersResponseDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeleteManyExternalDealFiltersResponseDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    deleted: json["deleted"],
    dealsTakenOffline: json["dealsTakenOffline"]
  };
}

export function DeleteManyExternalDealFiltersResponseDTOToJSON(
  value?: DeleteManyExternalDealFiltersResponseDTO | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    deleted: value.deleted,
    dealsTakenOffline: value.dealsTakenOffline
  };
}
